import imagevideo from './imagevideo'

export default {
  imagevideo,
}
